var exports = {
  "k": "StatusAvatar__JwUOC7",
};

module.exports = exports;
